import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { UntypedFormControl,Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'app-session-photo-source-add-dialog',
    standalone: true,
    templateUrl: './session-photo-source-add-dialog.component.html',
    styleUrls: ['./session-photo-source-add-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
]
})


export class SessionPhotoSourceAddDialogComponent {
    dialogRef = inject<MatDialogRef<SessionPhotoSourceAddDialogComponent, string>>(MatDialogRef);

    public photoSourceIdControl = new UntypedFormControl('', [
        Validators.required,
        Validators.max(255),
        Validators.pattern(/^[a-z0-9-]+$/)
    ]);

    create(photoSourceId: string): void {
        this.dialogRef.close(photoSourceId);
    }
}
